module.exports = __webpack_public_path__ + "img/c2.038dd32a.png";